import AdBanner from '../../../common/component/AdBanner';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import {IAdBanner} from '../../../common/type';
import {sendViewerEvent, sendViewerViewImp} from '../../common';
import {IViewType} from '../../type';

interface IProps {
  viewType: IViewType;
}

export default function ViewerBigBanner({viewType}: IProps) {
  const [episodeId, contentId, extendBanner] = useTypedSelector(({viewer}) => [
    viewer.episode?.id,
    viewer.episode?.contentId,
    viewer.viewerEnd?.extendBanner as IAdBanner,
  ]);

  const onClickBanner = (banner: IAdBanner) => {
    sendViewerEvent({
      actionName: 'banner',
      action: 'click',
      customProps: {
        content_id: contentId,
        episode_id: episodeId,
        banner_id: banner.id,
        event_layer: 'big_banner',
        viewer_type: viewType,
        cardgroup_id: banner.cardgroupId,
      },
    });
  };

  const sendBannerViewImp = (banner: IAdBanner) => {
    sendViewerViewImp({
      customProps: {
        content_id: contentId,
        episode_id: episodeId,
        banner_id: banner.id,
        event_layer: 'big_banner',
        viewer_type: viewType,
        cardgroup_id: banner.cardgroupId,
      },
    });
  };

  return (
    <AdBanner
      banner={extendBanner}
      contentId={contentId}
      onClick={() => onClickBanner(extendBanner)}
      onIntersection={isIntersecting => {
        isIntersecting && sendBannerViewImp(extendBanner);
      }}
    />
  );
}
